import Model from "../core/Model";
import { normalizedContextDrawImage } from "../Utils";

export default function (
    canvas: HTMLCanvasElement,
    grayscaleCanvas: HTMLCanvasElement,
    model: Model,
    cropAbsLeft = 0,
    cropAbsTop = 0
) {
    const absZoom = model.getAbsoluteZoom();

    // optimization attempt
    // let destWidth = grayscaleCanvas.width;
    // let destHeight = grayscaleCanvas.height;

    // if (absZoom > 1) {
        // destWidth = grayscaleCanvas.width * absZoom;
        // destHeight = grayscaleCanvas.height * absZoom;
    // }

    let context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.globalAlpha = 0.6;
    normalizedContextDrawImage(
        context,
        grayscaleCanvas,
        0,
        0,
        grayscaleCanvas.width,
        grayscaleCanvas.height,
        cropAbsLeft - model.getCropLeft(),
        cropAbsTop - model.getCropTop(),
        grayscaleCanvas.width * absZoom,
        grayscaleCanvas.height * absZoom
    );
    context.globalAlpha = 1;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/core/PaintSource.ts
 **/